(function ($)
{
    $.widget("ui.TagCategorySearchFilter",
        {
            options:
            {
                CategoryNameSelector: null
                , TrackerDisplayClass: 'tcsf_display'
                , ZeroSelectedContent: 'Any'
                , AllSelectedContent: 'All'
                , ItemContainerSelector: null
                , FilterControlsElementId: null
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);

                if (self.options.CategoryNameSelector === null
                    || self.options.TrackerDisplayClass === null
                    || self.options.ItemContainerSelector === null)
                {
                    return;
                }

                var lCategoryNameElement = jElement.find(self.options.CategoryNameSelector);
                var lItemContainerElement = jElement.find(self.options.ItemContainerSelector);

                if (lCategoryNameElement.length === 0
                    || lItemContainerElement.length !== 1)
                {
                    return;
                }

                lCategoryNameElement.append('<span class="' + self.options.TrackerDisplayClass + '"></span>');
                self._setTrackerText();

                lItemContainerElement.find('input').click(
                    function (aEvent)
                    {
                        self._toggleItem($(aEvent.target));
                        return true;
                    }
                );

                jElement.SlideOpener(
                    {
                        DisplaySelector: '.category_topper'
                        , SlidingContentSelector: '.items'
                    });
                jElement.find('.category_topper').click(
                    function (aEvent)
                    {
                        aEvent.preventDefault();
                        jElement.SlideOpener('ToggleSlider');
                        return false;
                    }
                );

                jElement.find('.category_topper').css('cursor', 'pointer');

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.FilterControlsElementId))
                {
                    jElement.find('input').attr('aria-controls', self.options.FilterControlsElementId);
                }
            },

            Reset: function ()
            {
                var self = this;
                var jElement = $(self.element);
                var lItemContainerElement = jElement.find(self.options.ItemContainerSelector);

                lItemContainerElement.find('input').prop("checked", false);

                self._setTrackerText();

                jElement.SlideOpener('CloseSlider');
            },

            _toggleItem: function (aTarget)
            {
                var self = this;
                var jElement = $(self.element);

                self._setTrackerText();
            },

            _setTrackerText: function ()
            {
                var self = this;
                var jElement = $(self.element);

                var lTrackerContainerElement = jElement.find(self.options.CategoryNameSelector);
                var lTrackerElement = lTrackerContainerElement.find('.' + self.options.TrackerDisplayClass);
                var lItemContainerElement = jElement.find(self.options.ItemContainerSelector);

                var lCount = lItemContainerElement.find('input' + ':checked').length;
                var lTotal = lItemContainerElement.find('input').length;

                if (lCount === 0)
                {
                    if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.ZeroSelectedContent) === false)
                    {
                        lCount = self.options.ZeroSelectedContent;
                    }
                }
                else if (lCount === lTotal)
                {
                    if (FBUtilities.IsParameterUndefinedOrEmpty(self.options.AllSelectedContent) === false)
                    {
                        lCount = self.options.AllSelectedContent;
                    }
                }

                lTrackerElement.html('(' + lCount + ')');
            }

        });
})(jQuery);